// extracted by mini-css-extract-plugin
module.exports = {"content":"PostContent_content__1w8Py"};